import React, { memo } from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';

import bot from '../img/bot.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons'


export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', padding:'5px', color:'white', borderRadius:'25px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
  }

    // var displayLabel= data.label + ":" + data.attributes["BizName"]
    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        // onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img draggable={false} src={bot} width='50' height='50'></img> */}
      <FontAwesomeIcon icon={faRobot} style={designerIconStyle} size='large'/>

      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});